import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfile,
  editProfile,
  getListProfile,
  getListTimeZone,
  getProfileAllowed,
  readProfile,
  readProfileByDomain,
  readProfileByDomainWidget,
  removeProfile,
} from "./thunkAction";

const initialState = {
  profiles: [],
  profile: {},
  listProfileAllowed: [],
  timeZones: [],
  loading: false,
  error: null,
  isLoadingAddProfile: false,
  addProfileError: null,
  isDomainUnknown: false,
};

const profileSlice = createSlice({
  name: "profileManage",
  initialState,
  reducers: {
    clearProfile(state) {
      state.profile = {};
    },
    resetProfileError(state) {
      state.error = null;
    },
    setProfile(state, action) {
      if (action.payload) {
        state.profile = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // getListProfile
      .addCase(getListProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListProfile.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const profiles = _.get(action, "payload", []);
        state.profiles = profiles;
      })
      .addCase(getListProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readProfile
      .addCase(readProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readProfile.fulfilled, (state, action) => {
        state.loading = false;
        const profile = _.get(action, "payload", {});
        state.profile = profile;
      })
      .addCase(readProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readProfileByDomain
      .addCase(readProfileByDomain.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readProfileByDomain.fulfilled, (state, action) => {
        state.loading = false;
        const profile = _.get(action, "payload", {});
        state.profile = profile;
      })
      .addCase(readProfileByDomain.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readProfileByDomain
      .addCase(readProfileByDomainWidget.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readProfileByDomainWidget.fulfilled, (state, action) => {
        state.loading = false;
        const profile = _.get(action, "payload", {});
        state.profile = profile;
      })
      .addCase(readProfileByDomainWidget.rejected, (state, action) => {
        state.loading = false;
        const error = action.payload;
        const errorCode = _.get(error, "errorCode");
        if (errorCode === "DOMAIN_UNKNOWN") {
          state.isDomainUnknown = true;
        }
        state.error = action.payload;
      })
      // addProfile
      .addCase(addProfile.pending, (state) => {
        state.isLoadingAddProfile = true;
        state.addProfileError = null;
      })
      .addCase(addProfile.fulfilled, (state, action) => {
        state.isLoadingAddProfile = false;
        state.profile = _.get(action, "payload");
      })
      .addCase(addProfile.rejected, (state, action) => {
        state.isLoadingAddProfile = false;
        state.addProfileError = action.payload;
      })
      // editProfile
      .addCase(editProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfile.fulfilled, (state, action) => {
        state.loading = false;
        const updatedProfile = _.get(action, "payload");
        state.profile = updatedProfile;
      })
      .addCase(editProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfile
      .addCase(removeProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfile.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // removeProfile
      .addCase(getProfileAllowed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProfileAllowed.fulfilled, (state, action) => {
        state.loading = false;
        state.listProfileAllowed = _.get(action, "payload", []);
      })
      .addCase(getProfileAllowed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }) // getListTimeZone
      .addCase(getListTimeZone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getListTimeZone.fulfilled, (state, action) => {
        state.loading = false;
        state.timeZones = _.get(action, "payload", []);
      })
      .addCase(getListTimeZone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileReducer = profileSlice.reducer;

export const profileAction = profileSlice.actions;
